// extracted by mini-css-extract-plugin
export var divider = "_ii-0";
export var systemMessage = "_ii-1";
export var systemMessageWrapper = "_ii-2";